import { CALL_API } from "../middleware/api";
export const FETCH_AUTH = 'FETCH_AUTH';
export const SUCCESS_AUTH = 'SUCCESS_AUTH';
export const FAILURE_AUTH = 'FAILURE_AUTH';

export const LOAD_AUTH = 'LOAD_AUTH';
export const SUCCESS_LOAD_AUTH = 'SUCCESS_LOAD_AUTH';
export const FAILURE_LOAD_AUTH = 'FAILURE_LOAD_AUTH';

export const LOSE_AUTH = 'LOSE_AUTH';

export function auth(data) {
    return {
        type: FETCH_AUTH,
        [CALL_API]: {
            endpoint: `/api/auth`,
            method: 'post',
            types: [SUCCESS_AUTH, FAILURE_AUTH],
            data
        }
    }
}

export function loadAuth() {
    return {
        type: LOAD_AUTH,
        [CALL_API]: {
            endpoint: `/api/auth/reauth`,
            method: 'post',
            types: [SUCCESS_LOAD_AUTH, FAILURE_LOAD_AUTH]
        }
    };
}

export function loseAuth() {
    return {
        type: LOSE_AUTH
    };
}


// WEBPACK FOOTER //
// ./src/actions/auth.js